<template>
<ValidationObserver ref="observer">
  <form ref="edit_client_master_form" @submit.prevent="handleSubmit(updateClientMaster)">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Client Master
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout md-glutter">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            Client No. (read)
          </label> -->
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="no" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Client No.</label>
                <md-input v-model="client_master.client_no" readonly/>
                <validation-error :errors="apiValidationErrors.client_no" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout md-glutter">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Name</span>
          </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Name</label>
                <md-input v-model="client_master.client_name" required/>
                <validation-error :errors="apiValidationErrors.client_name" />
              <span class="md-error">{{ errors[0] }}</span>
              </md-field>
                  </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Phone</span>
          </label> -->
              <validation-provider rules="digits_between:10,14" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Phone</label>
                <md-input v-model="client_master.client_phone" type="text" v-on:keypress="NumbersOnly"/>
                <validation-error :errors="apiValidationErrors.client_phone" />
              <span class="md-error">{{ errors[0] }}</span>
              </md-field>
                  </validation-provider>
          </div>
          <div class="md-layout-item -item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Email</span>
            </label> -->
              <md-field class="md-invalid" >
                <label>Email</label>
                <md-input v-model="client_master.client_email" type="email"/>
                <validation-error :errors="apiValidationErrors.client_email" />
              </md-field>
          </div>
        </div>
        <div class="md-layout md-glutter">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Address</span>
          </label> -->
              <md-field class="md-invalid" style="margin-bottom:20px;">
                <label>Address</label>
                <md-textarea v-model="client_master.client_address" md-counter="100" maxlength="100" md-autogrow></md-textarea>
                <md-avatar >
                  <md-icon style="color:blue;">report</md-icon>
                  <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                </md-avatar>
                <validation-error :errors="apiValidationErrors.client_address" />
              </md-field>
            </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , validate, localize , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import { min, max, numeric } from "vee-validate/dist/rules";
  import en from "vee-validate/dist/locale/en.json";
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

localize({
      en
  });

  extend("min", min);
  extend("max", max);
  extend("numeric", numeric);

// membuat input phone number dengan min dan max digit
  extend('digits_between', {
    async validate(value, { min, max }) {
          const res = await validate(value, `numeric|min:${min}|max:${max}`,)
              return res.valid;
    },
    params: ['min', 'max'],
    message: 'Phone must be between {min} and {max} digits'
  });

// mengirim pesan error ketika required field tidak diisi
extend('name', {
  ...required,
  message: 'Client Name field is required'
});
extend('no', {
  ...required,
  message: 'Client No. field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    name: "edit-service-categories-test",
    
    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

   data: () => ({
      client_master: []
    }),

    created() {
      this.getClientMasterData();
    },


    methods: {

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
      
      // fungsi untuk tombol direct ke list client master
      backtoList(id) {
      this.$router.replace({ name: 'List Client Master' })
    },

      // fungsi untuk mendapatkan data yang akan di edit dengan id yang dikirim bersamaan dengan route
      async getClientMasterData(){
        //check apakah id ada di route
        if(this.$route.params.id){
          
        //jika ada ambil data dari api
        await this.$store.dispatch("workshop_client_master/get", this.$route.params.id)
        this.client_master = await this.$store.getters["workshop_client_master/client_master"]
        }
        else{
          //jika tidak ada kembali ke list
          await this.$router.replace({name: 'List Client Master'});
        }
      },

      // validasi menggunakan sweetalert  sebelum mengubah data
      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateClientMaster(id)
          }
        });
    },


    // fungsi edit
      async updateClientMaster() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_client_master/update", this.client_master)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "Client Master data changed successfully.")
          //kembali ke list
          await this.$router.replace({name: 'List Client Master'});
        } catch (e) {
          //panggil notifikasi error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }

      }
    }
  };
</script>
